import React from 'react';

import {useUserDetails} from 'app/user/api';
import {SelectUsersSingle} from 'app/user/components/select';
import {gt} from 'app/utils/i18n';

import type {UserSerializedType} from 'sweet-types';

interface Props {
  disabled?: boolean;
  value?: string;
  onChange: (url: string) => Promise<unknown>;
}

export function TasksFilterbarAssignedUser({
  value,
  onChange,
  disabled,
}: Props): JSX.Element {
  const userId = extractUserIdFromValue();
  const users =
    userId != null
      ? useUserDetails(
          {id: userId},
          {refetchOnMountOrArgChange: false, skip: userId == null}
        ).data ?? null
      : null;

  function extractUserIdFromValue() {
    return value != null
      ? parseInt(value.split('/').splice(-2, 1)[0])
      : undefined;
  }

  return (
    <SelectUsersSingle<UserSerializedType>
      refetchDataOnOpen={true}
      selected={users}
      disabled={disabled}
      placeholder={gt('Filter by assigned teammate...')}
      onChange={(u?: UserSerializedType) => onChange(u != null ? u.url : '')}
    />
  );
}
